import { render } from "./OrdersHistory.vue?vue&type=template&id=4fde4939&ts=true"
import script from "./OrdersHistory.vue?vue&type=script&lang=ts"
export * from "./OrdersHistory.vue?vue&type=script&lang=ts"

import "./OrdersHistory.vue?vue&type=style&index=0&id=4fde4939&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__